/* eslint-env browser, jquery */
/* global WOW */
import domify from 'domify';
import page from 'modules/ab-page-js';
import container from 'modules/section-content';
import shuffle from 'shuffle-array';
import Batch from 'batch';
import rg from 'modules/npm-component/require-global';
import splash from './about-page.pug';
import metadata from './metadata.json';
import people from './people.json';

export default function register() {
  page('/about', render, loadScripts, initializeTeamSection);
}

function render(ctx, next) {
  const renderOptions = {
    metadata,
    // Only pass view on client render.
    ...(ctx.init ? {} : { view: domify(splash({ people })) })
  };
  container.render(renderOptions);

  next();
}

function loadScripts(ctx, next) {
  const batch = new Batch();

  batch.push(done => {
    rg('https://cdn.auth0.com/website/assets/pages/about/resources/jquery-697d69a48e.bxslider.min.js', 'bxslider', done);
  });

  batch.push(done => {
    rg('https://cdn.auth0.com/website/assets/pages/about/resources/owl-ffaa3c82ad.carousel.min.js', 'owl', done);
  });

  batch.push(done => {
    rg('//cdnjs.cloudflare.com/ajax/libs/wow/1.0.3/wow.min.js', 'WOW', done);
  });

  batch.end(next);
}

function initializeTeamSection(ctx, next) {
  $('.owl-carousel').owlCarousel({
    items: 1,
    responsiveRefreshRate: 10,
    dots: false,
    nav: true,
    mouseDrag: false,
    lazyLoad: true,
    navText: ''
  });

  // Random list
  const $members = $('.team article');
  const $rows = $('.team section, .slider section');
  const list = $members.get();

  shuffle(list);

  $rows.each(function() {
    const $row = $(this);

    $row.empty();

    for (let i = 0; i < list.length; i += 1) {
      $row.append($(list[i]).clone());
    }
  });

  new WOW().init();

  const team = $('.team-slider section').bxSlider({
    minSlides: 3,
    maxSlides: 3,
    moveSlides: 1,
    slideWidth: 240,
    slideMargin: 20,
    pager: false,
    controls: false,
    onSliderLoad(currentIndex) {
      $(".team-slider article:not([class='bx-clone'])")
        .eq(currentIndex + 1)
        .addClass('active-slide');
    },

    onSlideBefore($slideElement) {
      $('.team-slider article').removeClass('active-slide');
      $slideElement.next().addClass('active-slide');
    }
  });

  $('.team article').click(function() {
    $('.team-slider').addClass('active');
    team.goToSlide($(this).index() - 1);
  });

  $('.overlay').click(() => {
    $('.team-slider').removeClass('active');
  });

  // Scroll to href ID
  $('a[data="scroll-to"]').click(function() {
    if (
      location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') &&
      location.hostname == this.hostname
    ) {
      let $target = $(this.hash);
      $target = $target.length ? $target : $(`[name=${this.hash.slice(1)}]`);
      if ($target.length) {
        $('html,body').animate(
          {
            scrollTop: $target.offset().top
          },
          1000
        );
        return false;
      }
    }
  });

  next();
}



// WEBPACK FOOTER //
// ./src/pages/about/about.js